import { render, staticRenderFns } from "./ConnectedChannelsSection.vue?vue&type=template&id=6b560720&scoped=true"
import script from "./ConnectedChannelsSection.vue?vue&type=script&lang=js"
export * from "./ConnectedChannelsSection.vue?vue&type=script&lang=js"
import style0 from "./ConnectedChannelsSection.vue?vue&type=style&index=0&id=6b560720&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b560720",
  null
  
)

export default component.exports